import { render } from "./BalavediMadrasa.vue?vue&type=template&id=1dff3fc4&scoped=true"
import script from "./BalavediMadrasa.vue?vue&type=script&lang=js"
export * from "./BalavediMadrasa.vue?vue&type=script&lang=js"

import "./BalavediMadrasa.vue?vue&type=style&index=0&id=1dff3fc4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dff3fc4"]])

export default __exports__